import TakeActionForm from 'src/components/dashboard_take_actions/take_action_form';
import { FilesProvider } from 'src/context/files.jsx';
import { TakeActionsProvider } from 'src/context/take_action';

const Page = () => (
	<FilesProvider>
		<TakeActionsProvider>
			<TakeActionForm />
		</TakeActionsProvider>
	</FilesProvider>
);

export default Page;
